<app-orderhistory-page
  [loading]="loading$ | async"
  [orderHistory]="orderHistory$ | async"
  [loading]="loading$ | async"
  [expanding]="expanding$ | async"
  [currency]="currency$ | async"
  (onExpand)="expand()">
</app-orderhistory-page>
